import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useTrackPreviousLocation = () => {
    const location = useLocation();

    useEffect(() => {
        const previousLocation = sessionStorage.getItem('previousLocation');
        if (location.pathname !== previousLocation) {
            sessionStorage.setItem('previousLocation', location.pathname);
        }
    }, [location]);
};

export default useTrackPreviousLocation;
